import { isSameDay, setHours, setMinutes, setSeconds } from 'date-fns';

export const handleValidFromDate = (validTo: Date | null) => {
  if (!validTo) return null;

  if (isSameDay(validTo, new Date())) return validTo;

  return setHours(setMinutes(setSeconds(validTo, 0), 0), 0);
};
